export default "__VITE_ASSET__BQ5Mij3j__"